import { render, staticRenderFns } from "./detailed-monthly.vue?vue&type=template&id=bc99ec3a&"
import script from "./detailed-monthly.vue?vue&type=script&lang=js&"
export * from "./detailed-monthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports